import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "speachGenerationLoader"
};
const _hoisted_2 = {
  class: "sglLabel"
};
const _hoisted_3 = {
  class: "sglCount"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_progress = _resolveComponent("el-progress");
  return _ctx.inProgress > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('aiSpeachGenerator.chaptersInGeneration', {
    count: _ctx.inProgress
  })), 1), _createVNode(_component_el_progress, {
    class: "sglProgress",
    percentage: _ctx.progressPercent,
    indeterminate: true,
    duration: 1,
    "stroke-width": 6,
    "show-text": false
  }, null, 8, ["percentage"]), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.speachDone) + " / " + _toDisplayString(_ctx.speachTotal), 1)])) : _createCommentVNode("", true);
}